module.exports = __webpack_public_path__ + "img/logo.fe26f9ea.png";